// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-check label{margin-left:4px;margin-top:4px;font-size:18px;font-weight:500}.form-check .form-check-input[type=checkbox]{border-radius:.25em;height:25px;width:25px}.my-header{background:#000!important;border-color:#000!important;font-size:16px;color:#fff}.el-table__body-wrapper{z-index:2}.el-table .cell{font-size:18px;white-space:pre-line;overflow:unset}", ""]);
// Exports
module.exports = exports;
